import { useTranslation } from 'react-i18next';
import { InputNumber } from 'antd';
import { createCheckboxField } from './createCheckboxField';
/**
 * A React component that defines and returns an array of field configurations
 * for capturing outside information in a form. It utilizes the `useTranslation`
 * hook from `react-i18next` to provide translations for the label of each
 * checkbox.
 *
 * @returns {Object} An object containing the following properties:
 * - `outsideInformationsFields`: An array of objects, each representing a field
 *   configuration for a checkbox input capturing various outside area features.
 *   The configurations include properties such as `noLabel`, `label`, `name`,
 *   `input`, and `valuePropName`.
 *
 * @function
 * @example
 *
 * import OutsideInformations from './OutsideInformations';
 *
 * const { outsideInformationsFields } = OutsideInformations();
 *
 * // Now, outsideInformationsFields can be used to generate a form or part of a form
 */
const OutsideInformations = () => {
  const { t } = useTranslation();

  const outsideInformationsFields = [
    createCheckboxField('outside', 'garden', t),
    createCheckboxField('outside', 'closed', t),
    {
      label: 'type_of_storage_for_pensioner.outside.surface',
      name: [
        'petsitting_address',
        'type_of_storage_for_pensioner',
        'outside',
        'surface'
      ],
      input: <InputNumber addonAfter="m²" />
    },
    createCheckboxField('outside', 'gardener_during_supervision', t),
    createCheckboxField('outside', 'automatic_spraying', t),
    createCheckboxField('outside', 'external_plant', t),
    {
      label: 'type_of_storage_for_pensioner.outside.external_time_to_give',
      name: [
        'petsitting_address',
        'type_of_storage_for_pensioner',
        'outside',
        'external_time_to_give'
      ]
    },
    createCheckboxField('outside', 'interior_plant', t),
    {
      label: 'type_of_storage_for_pensioner.outside.interior_time_to_give',
      name: [
        'petsitting_address',
        'type_of_storage_for_pensioner',
        'outside',
        'interior_time_to_give'
      ]
    },
    createCheckboxField('outside', 'swimming_pool', t),
    {
      label: 'type_of_storage_for_pensioner.outside.to_maintain',
      name: [
        'petsitting_address',
        'type_of_storage_for_pensioner',
        'outside',
        'to_maintain'
      ]
    },
    createCheckboxField('outside', 'jacuzzi', t),
    {
      label: 'type_of_storage_for_pensioner.outside.detail',
      name: [
        'petsitting_address',
        'type_of_storage_for_pensioner',
        'outside',
        'detail'
      ]
    },
    createCheckboxField('outside', 'garden_furniture', t),
    createCheckboxField('outside', 'barbecue', t),
    createCheckboxField('outside', 'balcony', t),
    createCheckboxField('outside', 'patio', t)
  ];

  return {
    outsideInformationsFields
  };
};

export default OutsideInformations;
